export default __webpack_public_path__ + "static/media/magnifying-glass-white.80b99add.svg";